import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';

const initialState = { 
    feesDiscountListing: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    classId: '0',
    searchText: '',
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const FeesDiscountContext = createContext();

export const FeesDiscountProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(()=>{
      if(state.mounted){
        getFeesDiscountListing();
      }
    }, [state.currentPage])

  const getFeesDiscountListing = async (refresh = false) => {

    dispatch({ type: "mounted", payload: true });

    if (refresh) {
        dispatch({ type: "feesDiscountListing", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
      }

    const server_response  = await ajaxSchool.fetchRecurringDiscounts({
        'page':refresh ? 1: state.currentPage,
        'class_id': state.classId
      });
      if(server_response.status === "OK"){
        
            const newTransactions = server_response.details.data;
            dispatch({
            type: "feesDiscountListing",
            payload: refresh
                ? newTransactions
                : state.feesDiscountListing
                ? [...state.feesDiscountListing, ...newTransactions]
                : newTransactions
            });

          dispatch({ type: "metaData", payload: server_response.details.meta });

      }else{
        dispatch({ type: 'feesDiscountListing', payload: '404' });
        dispatch({ type: "meta", payload: "404" });

      }
  };

  
  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const filter = async()=>{
    await getFeesDiscountListing(true);
  }


  return(
    <FeesDiscountContext.Provider value={{
      ...state, 
      dispatch, 
      getFeesDiscountListing,
      setCurrentPage,
      filter
      }}>
      {children}
    </FeesDiscountContext.Provider>
  )

}

export const useFeesDiscount = ()=>useContext(FeesDiscountContext);

